module.exports = __webpack_public_path__ + "static/media/teams-logo.e97b7245.svg";


//////////////////
// WEBPACK FOOTER
// ./src/icons/teams-logo.svg
// module id = 1715
// module chunks = 0